/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export enum SearchOption {
    OrderNumber = 0,
    ConfirmationId = 1,
    ChannelName = 2,
    CustomerRequisition = 3
}
